import { useLocation } from 'react-router-dom';
import { AutomationsTab, AutomationsTabType } from './Automations.constants';

export const defaultAutomationTab = AutomationsTab.systemTemplates;

const useAutomationsActiveTab = (): AutomationsTabType => {
  const { pathname } = useLocation();
  const pathSegments = pathname.split('/').filter(Boolean);

  return (
    Object.values(AutomationsTab).find((tab) => pathSegments.includes(tab)) ??
    defaultAutomationTab
  );
};

export default useAutomationsActiveTab;
